<template>
    <div v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="limit"  class="p-portfolio__inner" v-if="offers">
        <section class="portfolio-item" v-for="offer in offers" data-aos="slide-up" data-aos-offset="100" data-aos-easing="ease-out-back">
            <img class="portfolio-item__img lazy" :src="offer.preview_url"
                 :alt="offer.name">
            <div class="portfolio-item__inner">
                <h2 class="portfolio-item__title h4">{{ offer.name }}</h2>
                <a class="portfolio-item__link btn _border" :href="offer.url">Подробнее</a>
                <p class="portfolio-item__desc">{{ offer.text }}</p>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "offers",
        data: () => ({
            offers: [],
            busy: false,
            limit: 6,
            page: 1,
            last_page: null
        }),
        mounted() {
            this.loadMore();
        },
        methods: {
            loadMore: function() {
                if(!this.last_page || this.page <= this.last_page) {
                    this.busy = true;
                    this.$http.get('/api/offers?page='+this.page).then(res => {
                        res.data.data.forEach((el) => {
                            this.offers.push(el);
                        });
                        this.busy = false;
                        this.page++;
                        this.last_page = res.data.meta.pagination.last_page;
                    });
                }

            }
        }
    }
</script>

<style scoped>

</style>